// @ts-ignore
import englishMessages from 'ra-language-english';

export const messages = {
  simple: {
    action: {
      close: 'Close',
      resetViews: 'Reset views',
    },
    'create-post': 'New post',
    login: {
      title: 'Login',
    },
    email: 'Email',
    password: 'Password',
    role: 'Role',
    admin: 'Admin',
    guest: 'Guest',
    owner: 'Owner',
    required_email: 'Please enter your e-mail address',
    logout: 'Logout',
    checked_in: 'Checked-In',
    today: 'Today',
    yesterday: 'Yesterday',
    last_week: 'Last week',
    add_new_field: 'Add New Field',
    new_field_name: 'New Field Name',
    added_fields: 'Added Fields',
    deleted_fields: 'Deleted Fields',
    renamed_fields: 'Renamed Fields',
    confirm_template_changes: 'Confirm Template Changes',
    reselect: 'Reselect',
    select_a_photo: 'Select a photo',
    field_name_is_required: 'Field name is required',
    image_is_required: 'Image is required',
  },
  form_submission: {
    fields: {
      id: 'ID',
      template_name: 'Template Name',
      image: 'Image',
      submitted_data: 'Submitted Data',
      actions: 'Actions',
      client: 'Client',
      created_at: 'Created At',
      updated_at: 'Updated At',
      name: 'Name',
      form_extract_key: 'Form Extract Key',
      expected_data: 'Expected Data',
      note: 'Comment',
    },
    actions: {
      view_detail: 'View Detail',
      delete: 'Delete',
      edit: 'Edit',
    },
    notification: {
      created_success: 'Form submission created successfully',
      created_error: 'Error creating form submission',
      updated_success: 'Form submission updated successfully',
      updated_error: 'Error occurred while updating form submission',
    },
    show: {
      title: 'Form Submission Details',
      basic_info: 'Basic Information',
      template_info: 'Template Information',
    },
    create: {
      title: 'Create New Form Submission',
      template_selection: 'Template Selection',
      client_info: 'Client Information',
      submitted_data: 'Submitted Data',
      submitted_data_help: 'Enter the form data as JSON format',
      image_upload: 'Image Upload',
      form_info: 'Form Information',
    },
    edit: {
      title: 'Edit form submission',
      image_upload: 'Image Upload',
      form_info: 'Form Information',
      no_image: 'No image available',
    },
    errors: {
      loading_image: 'Error loading image',
      no_analysis_queue: 'No analysis queue found',
      no_image: 'No image found in analysis queue',
    },
  },
  prompts: {
    list: {
      title: 'Form Extract Prompts',
    },
    fields: {
      version: 'Version',
      prompt: 'Prompt Content',
      actions: 'Actions',
      updated_at: 'Updated',
      key: 'Key',
    },
    actions: {
      edit: 'Edit',
    },
  },
  resources: {
    users: {
      name: 'User |||| Users',
      fields: {
        name: 'Name',
        role: 'Role',
        display_name: 'Display Name',
        email: 'Email',
        first_name: 'First Name',
        last_name: 'Last Name',
        plan: 'Plan',
        current_period_start: 'Current Period Start',
        current_period_end: 'Current Period End',
      },
    },
    guest: {
      name: 'Guests',
      fields: {
        create_key: 'Create Key',
        name: 'Name',
        position: 'Position',
        company_name: 'Company Name',
        work_phone: 'Work Phone',
        mobile: 'Mobile',
        updated_at: 'Updated At',
        email: 'Email',
        fax: 'Fax',
        website: 'Website',
        others: 'Others',
        business_card: 'Business Card',
        name_jp: 'Name JP',
        name_en: 'Name EN',
        title: 'Title',
        company_address: 'Company Address',
        company_short_name: 'Company Short Name',
      },
      actions: {
        create_key: 'Add',
      },
    },
    form_template: {
      name: 'Form Template |||| Form Templates',
      fields: {
        name: 'Name',
        description: 'Description',
        form: 'Form',
        form_fields: 'Form Fields',
      },
      notification: {
        saved_success: 'Saved successfully',
        saved_error: 'Error during saving',
        deleted_success: 'Deleted successfully',
        deleted_error: 'Error during deleting',
        confirm_delete: 'Are you sure you want to delete this item?',
      },
    },
    client: {
      name: 'Client |||| Clients',
      fields: {
        name: 'Name',
        description: 'Description',
        chatwork_api_token: 'Chatwork API Token',
        chaatwork_room: 'Chatwork Room',
        slack_token: 'Slack Token',
        slack_channel_id: 'Slack Channel ID',
        updated_by: 'Updated By',
        updated_at: 'Updated At',
      },
    },
    subscriptions: {
      name: 'Subscription |||| Subscriptions',
      fields: {
        user_id: 'User ID',
        plan_id: 'Plan ID',
        current_period_start: 'Current Period Start',
        current_period_end: 'Current Period End',
        client: 'Client',
        user: 'User',
        first_name: 'First Name',
        last_name: 'Last Name',
        email: 'Email',
        display_name: 'Display Name',
        updated_at: 'Updated At',
        updated_by: 'Updated By',
        created_at: 'Created At',
        created_by: 'Created By',
      },
    },
    settings: {
      name: 'Settings',
      fields: {
        name: 'Name',
        value: 'Value',
        description: 'Description',
        updated_at: 'Updated At',
        key: 'Key',
        updated_by: 'Updated By',
      },
    },
    log: {
      name: 'Log',
      fields: {
        title: 'Title',
        module: 'Module',
        level: 'Level',
        created_at: 'Created At',
        message: 'Message',
        created_by: 'Created By',
      },
    },
    user_device_tokens: {
      name: 'User Device Token |||| User Device Tokens',
      fields: {
        id: 'ID',
        user_id: 'User ID',
        device_id: 'Device ID',
        fcm_token: 'FCM Token',
        is_subscribed: 'Is Subscribed',
        created_at: 'Created At',
        updated_at: 'Updated At',
      },
    },
    notification_details: {
      name: 'Notification Detail |||| Notification Details',
      fields: {
        id: 'ID',
        notification_id: 'Notification ID',
        payload: 'Payload',
        tokens: 'Tokens',
        status: 'Status',
        created_at: 'Created At',
        updated_at: 'Updated At',
      },
    },
  },
  common: {
    save_success: 'Saved successfully',
    saved_error: 'Error during saving',
    main_information: 'Main Information',
  },
  user: {
    list: {
      search: 'Search',
    },
    form: {
      summary: 'Summary',
      security: 'Security',
    },
    action: {
      save_and_add: 'Save and Add',
      save_and_show: 'Save and Show',
    },
  },
  ...englishMessages,
};

export default messages;
